import React, { Fragment, useState } from 'react';
import { Button, Box, Typography, TextField, Grid, Dialog, DialogActions, DialogTitle, DialogContent, useMediaQuery, useTheme, Divider, Icon, CircularProgress } from '@mui/material';
import Paper from '@mui/material/Paper';
import { useNavigate } from 'react-router-dom';

import {
    useTranslate,
} from 'react-admin'
import PageDividerText from 'src/components/customComponents/B2/PageDividerText';
import 'dayjs/locale/es'
import dayjs from 'dayjs';
import { Document, Thumbnail, pdfjs } from 'react-pdf';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { billingFormServices } from 'src/services/payment/billingForm/billingForm.service';
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

function ConfirmationModal({
    open,
    handleClose,
    sendForm,
    finalPaymentData,
    cash,
    cards,
    banks,
    currencies,
    totalDeclared,
    totalSelected,
    finalBalance
}) {
    dayjs.locale('es');
    const translate = useTranslate();
    const [showConfimationInfo, setShowConfimationInfo] = useState(true);
    const [showSuccessConfimationInfo, setShowSuccessConfimationInfo] = useState(null);
    const [msgConfimationInfo, setMsgConfimationInfo] = useState([]);
    const [isLoadingResponse, setIsLoadingResponse] = useState(false);
    const navigate = useNavigate();


    const PdfPreview = ({ pdfFile }) => {
        return (
            <div >
                <Document file={pdfFile} onLoadSuccess={console.log}>
                    <Thumbnail pageNumber={1} height={120} />
                </Document>
            </div>
        );
    };

    const onSave = () => {
        sendForm(); // Llamar al método de guardar con los datos del formulario.
        handleClose(); // Cerrar el modal después de guardar.
        setShowConfimationInfo(true)
    };

    const handleSubmit = async () => {
        setIsLoadingResponse(true)
        const formData = new FormData()
        const newPaymentData = { ...finalPaymentData };
        delete newPaymentData.selectedBusinessUnit;

        let allFiles = [];
        newPaymentData.payments.forEach(payment => {
            payment.retentions = payment.retentions.filter(retention => retention.type !== "Total Retenciones");
            payment.retentions.forEach(retention => {
                if (retention.files && retention.files.length > 0) {
                    // Guardar los nombres de los archivos dentro de retentions
                    retention.files = retention.files.map(file => {
                        // Agregar el archivo completo al array de allFiles
                        allFiles.push(file); // Guarda el archivo completo
                        return file.name; // Devuelve el nombre para la retención
                    });
                }
                retention.amount = parseFloat(retention.amount.replace(/\./g, '').replace(',', '.'))
            });
        });

        newPaymentData.reservations_info.forEach(reservation => {
            const { status_payment, payment_amount, destination_prices } = reservation;

            reservation.reservation_payment = {
                type: status_payment ? status_payment : "Total",
                amount: payment_amount ? payment_amount : destination_prices.pending_amount
            };

            //delete reservation.payment_amount;
            //delete reservation.status_payment;
        });

        if (allFiles.length > 0) {
            for (let m in allFiles) {
                formData.append('files', allFiles[m], allFiles[m].name);
            }
        }

        let dataFinalString = JSON.stringify(newPaymentData)
        formData.append("data", dataFinalString)

        try {
            const response = await billingFormServices.uploadBillingForm(formData)
            setShowSuccessConfimationInfo(true)
            setMsgConfimationInfo([translate('ra.message.paymentRegisteredSuccess'), translate('ra.message.paymentAppliedToReservations')])
        } catch (error) {
            setShowSuccessConfimationInfo(false)
            setMsgConfimationInfo([translate('ra.message.paymentRegistrationError'), translate('ra.message.tryAgain')])
        } finally {
            setShowConfimationInfo(false)
            setIsLoadingResponse(false)
        }
    }

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    { handleClose() }
                }
            }}
            fullWidth
            maxWidth={`${showConfimationInfo ? 'md' : 'sm'}`}
            className='generalDialogContainer dialogInfoToConfirm'
            disableEscapeKeyDown
        >
            {/* HEADER */}
            <DialogTitle className={`dialogTitle`}>
                {showConfimationInfo ?
                    translate('ra.title.requestConfirmation')
                    :
                    (showSuccessConfimationInfo && showSuccessConfimationInfo === true) ?
                        translate('ra.message.completed')
                        :
                        translate('ra.message.attention')
                }


            </DialogTitle>

            {showConfimationInfo ?
                <DialogContent dividers className='dialogContent'>
                    <Grid container spacing={3} >
                        <Grid item xs={12} md={12} lg={12} xl={12} >
                            <p> {translate('ra.message.confirmOrEditData')}
                            </p>
                        </Grid>

                        {/* Start General info */}
                        <Grid item xs={12} md={12} lg={12} xl={12} >
                            <Grid container spacing={3} >
                                <Grid item xs={12} md={12} lg={12} xl={12} >
                                    <PageDividerText content={translate('ra.title.applicant')} />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6} xl={6}  >
                                    {finalPaymentData?.user_info?.name &&
                                        <div className='dataInfo'>
                                            <span className='column left'> {translate('ra.field.username')} :</span>
                                            <span className='column right'>{finalPaymentData?.user_info?.name} {finalPaymentData?.user_info?.surname}</span>
                                        </div>
                                    }
                                    {finalPaymentData?.user_info?.email &&
                                        <div className='dataInfo'>
                                            <span className='column left'>Email:</span>
                                            <span className='column right'>{finalPaymentData?.user_info?.email}</span>
                                        </div>
                                    }
                                    {finalPaymentData?.business_unit_info?.long_name &&
                                        <div className='dataInfo'>
                                            <span className='column left'>{translate('ra.field.business_unit')}:</span>
                                            <span className='column right'>{finalPaymentData?.business_unit_info?.long_name}</span>
                                        </div>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* End General info */}

                        {/* Start Payment info */}
                        <Grid item xs={12} md={12} lg={12} xl={12} >
                            <Grid container spacing={3} >
                                <Grid item xs={12} md={12} lg={12} xl={12} >
                                    <PageDividerText content={translate('ra.title.paymentDetails')} />
                                </Grid>

                                {finalPaymentData?.payments?.map((payment) => (
                                    <Fragment>
                                        <Grid item xs={12} md={6} lg={6} xl={6}  >
                                            {payment?.payment_type &&
                                                <div className='dataInfo'>
                                                    <span className='column left'>{translate('ra.field.payment_type')}</span>
                                                    <span className='column right'>{payment?.payment_type}</span>
                                                </div>
                                            }
                                            {payment?.bank_info &&
                                                <>
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.bank')}</span>
                                                        <span className='column right'>{payment?.bank_info.name}</span>
                                                    </div>
                                                    {payment?.bank_info.document_number &&
                                                        <div className='dataInfo'>
                                                            <span className='column left'>{translate('ra.field.document_number')}</span>
                                                            <span className='column right'>{payment?.bank_info.document_number || 'No cargado'}</span>
                                                        </div>
                                                    }
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.coupon_number')}</span>
                                                        <span className='column right'>{payment?.bank_info.coupon_number || 'No cargado'}</span>
                                                    </div>
                                                </>
                                            }
                                            {payment.check_info && (
                                                <>
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.bank')}</span>
                                                        <span className='column right'>{payment?.check_info.bank_name}</span>
                                                    </div>
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.check_type')}</span>
                                                        <span className='column right'>{payment?.check_info.type}</span>
                                                    </div>
                                                    {payment?.check_info.type === 'diferido' &&
                                                        <div className='dataInfo'>
                                                            <span className='column left'>{translate('ra.field.date_emision')}</span>
                                                            <span className='column right'>{new Date(payment?.check_info.date_emision).toLocaleDateString('es-ES')}</span>
                                                        </div>
                                                    }
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.coupon_number')}</span>
                                                        <span className='column right'>{payment?.check_info.coupon_number}</span>
                                                    </div>
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.customer_name')}</span>
                                                        <span className='column right'>{payment?.check_info.customer_name}</span>
                                                    </div>
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.document_number')}</span>
                                                        <span className='column right'>{payment?.check_info.document_number}</span>
                                                    </div>
                                                </>
                                            )}
                                            {payment.cash_info && (
                                                <>
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.entity.cash')}</span>
                                                        <span className='column right'>{payment?.cash_info.name}</span>
                                                    </div>
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.customer_name')}</span>
                                                        <span className='column right'>{payment?.cash_info.customer_name}</span>
                                                    </div>
                                                </>
                                            )}
                                            {payment.wallet_info && (
                                                <>
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.payment_id')}</span>
                                                        <span className='column right'>{payment?.wallet_info.payment_id}</span>
                                                    </div>
                                                </>
                                            )}
                                            {payment.card_info && (
                                                <>
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.card')}</span>
                                                        <span className='column right'>{payment?.card_info.long_name}</span>
                                                    </div>
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.customer_name')}</span>
                                                        <span className='column right'>{payment?.card_info.customer_name}</span>
                                                    </div>
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.card_number')}</span>
                                                        <span className='column right'>{payment?.card_info.card_number}</span>
                                                    </div>
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.expiry_date')}</span>
                                                        <span className='column right'>{new Date(payment.card_info.expiry_date).toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit' })}</span>
                                                    </div>
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.quota')}</span>
                                                        <span className='column right'>{payment?.card_info.quotes}</span>
                                                    </div>
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.coupon_number')}</span>
                                                        <span className='column right'>{payment?.card_info.coupon_code}</span>
                                                    </div>
                                                    <div className='dataInfo'>
                                                        <span className='column left'>{translate('ra.field.auth_code')}</span>
                                                        <span className='column right'>{payment?.card_info.auth_code}</span>
                                                    </div>
                                                </>
                                            )}
                                            {payment?.payment_date &&
                                                <div className='dataInfo'>
                                                    <span className='column left'>{translate('ra.field.payment_date')}</span>
                                                    <span className='column right'>{dayjs(payment?.payment_date).format('YYYY MMMM DD')}</span>
                                                </div>
                                            }
                                            {payment?.amount &&
                                                <div className='dataInfo'>
                                                    <span className='column left'>{translate('ra.field.amount')}</span>
                                                    <span className='column right'>{payment?.currency_info.short_name} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(payment?.amount))}</span>
                                                </div>
                                            }
                                        </Grid>
                                        {/* start retention */}
                                        <Grid item xs={12} md={6} lg={6} xl={6}  >
                                            {payment?.retentions?.map((retention) => (
                                                retention?.type !== "Total Retenciones" && (
                                                    <Fragment>
                                                        <Grid container spacing={1} style={{ marginBottom: 15 }}>
                                                            <Grid item xs={12} md={12} lg={12} xl={12}  >
                                                                <PageDividerText content={translate('ra.field.retention')} withOutLine={true} />
                                                                {retention?.amount &&
                                                                    <div className='dataInfo'>
                                                                        <span className='column left'>{translate('ra.field.retention_amount')}</span>
                                                                        <span className='column right'>{retention?.amount}</span>
                                                                    </div>
                                                                }
                                                                {retention?.certificate &&
                                                                    <div className='dataInfo'>
                                                                        <span className='column left'>{translate('ra.field.retention_certificate')}</span>
                                                                        <span className='column right'>{retention?.certificate}</span>
                                                                    </div>
                                                                }
                                                                {retention?.type &&
                                                                    <div className='dataInfo'>
                                                                        <span className='column left'>{translate('ra.field.retention_type')}</span>
                                                                        <span className='column right'>{retention?.type}</span>
                                                                    </div>
                                                                }
                                                            </Grid>

                                                            {retention?.files?.map((file, index) => (
                                                                <Grid item xs={12} md={6} lg={6} xl={6} className="imagesThumbnails" key={index}>
                                                                    {file instanceof File ? (
                                                                        file.type === 'application/pdf' ? (
                                                                            <PdfPreview pdfFile={URL.createObjectURL(file)} />
                                                                        ) : (
                                                                            <img src={URL.createObjectURL(file)} alt={`Comprobante ${index + 1}`} className="image" />
                                                                        )
                                                                    ) : (
                                                                        <div className="text">El objeto no es un archivo</div>
                                                                    )}
                                                                    <div className="text">{file.name}</div>
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    </Fragment>
                                                )
                                            ))}


                                        </Grid>
                                        {/* end retention */}
                                    </Fragment>
                                ))}
                            </Grid>
                        </Grid>
                        {/* End Payment info */}

                        {/* Start Reservation info */}
                        <Grid item xs={12} md={12} lg={12} xl={12} >
                            <Grid container spacing={3} >
                                <Grid item xs={12} md={12} lg={12} xl={12} >
                                    <PageDividerText content={translate('ra.title.selectedReservations')} />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6} xl={6}  >
                                    <div className='scrollingContainer'>
                                        <table className='tableInfoConfimation'>
                                            <tr className='tableHead'>
                                                <th className='cell'>{translate('ra.field.reservationNumber')}</th>
                                                <th className='cell'>{translate('ra.field.paidAmount')}</th>
                                            </tr>
                                            {finalPaymentData?.reservations_info?.map((reservation) => (
                                                <>
                                                    <tr className='tableBody'>
                                                        <td className='cell '> {reservation.number} </td>
                                                        <td className='cell '> {finalPaymentData?.payments[0]?.currency_info.short_name} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(reservation.payment_amount ? reservation.payment_amount : reservation.destination_prices.pending_amount))} </td>
                                                    </tr>
                                                </>
                                            ))
                                            }
                                        </table>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* End Reservation info */}

                        {/* Start Reservation info */}
                        <Grid item xs={12} md={12} lg={12} xl={12} >
                            <Grid container spacing={3} >
                                <Grid item xs={12} md={12} lg={12} xl={12} >
                                    <PageDividerText content={translate('ra.title.totals')} />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6} xl={6}  >
                                    <div className='dataInfo'>
                                        <span className='column left bigger'>{translate('ra.field.declaredTotal')}:</span>
                                        <span className='column right bigger'>{finalPaymentData?.payments?.[0]?.currency_info.short_name} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(totalDeclared))}</span>
                                    </div>
                                    <div className='dataInfo'>
                                        <span className='column left bigger'>{translate('ra.field.selectedTotal')}:</span>
                                        <span className='column right bigger'>{finalPaymentData?.payments?.[0]?.currency_info.short_name} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(totalSelected))}</span>
                                    </div>
                                    <div className='dataInfo'>
                                        <span className='column left bigger'>{translate('ra.field.finalBalance')}:</span>
                                        <span className='column right bigger'>{finalPaymentData?.payments?.[0]?.currency_info.short_name} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(finalBalance))}</span>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* End Reservation info */}


                    </Grid>
                </DialogContent>
                :
                <DialogContent dividers className='dialogContent' >
                    <Grid container spacing={3} >
                        <Grid item xs={12} md={12} lg={12} xl={12} >
                            {showSuccessConfimationInfo && showSuccessConfimationInfo === true ?
                                <div className='submitMessagesFeedback'>
                                    <Typography variant="h4" component="h4" className='title'> <Icon className='icon'>check_circle</Icon> {msgConfimationInfo[0]} </Typography>
                                    <Typography variant="body1" component="p" className='message'>{msgConfimationInfo[1]}</Typography>
                                </div>
                                :
                                <div className='submitMessagesFeedbackFail'>
                                    <Typography variant="h4" component="h4" className='title'> <Icon className='icon'>error</Icon> {msgConfimationInfo[0]}</Typography>
                                    <Typography variant="body1" component="p" className='message'>{msgConfimationInfo[1]}</Typography>
                                </div>
                            }
                        </Grid>
                    </Grid>
                </DialogContent>
            }

            <DialogActions className='dialogActions'>
                {showConfimationInfo ?
                    <Fragment>
                        <Button size="large" onClick={handleClose} variant="outlined">
                            {translate('ra.action.cancel')}
                        </Button>
                        <Button size="large" startIcon={<Icon>transit_enterexit</Icon>} onClick={() => handleSubmit()} variant="contained" disabled={isLoadingResponse} >
                            {isLoadingResponse ?
                                <CircularProgress />
                                :
                                translate('ra.action.save')
                            }
                        </Button>
                    </Fragment>
                    :
                    <Fragment>
                        <Button size="large" startIcon={<Icon>home</Icon>} onClick={() => navigate('/billingform')}
                            variant="outlined" color="inherit">
                            {translate('ra.action.close')}
                        </Button>
                        <Button size="large" color="primary" startIcon={<Icon>add</Icon>} onClick={onSave} variant="contained" >
                            {translate('ra.action.addAnotherPaymentRecord')}
                        </Button>
                    </Fragment>
                }
            </DialogActions>
        </Dialog>
    )

}

export default ConfirmationModal;
